<template>
	<!-- 关注 -->
	<div class="followBox">
		<!-- v-if="collect_author.length" -->
		<div class="followBoxItem">
			<!-- 排序方式 -->
			<div class="solt">
				<div @click="toggle('author')">
					<span>我收藏的作者</span>
					<img :class="selectItem == true ? 'up' : ''" src="../../assets/img/downarr.png" alt="" />
				</div>
				<!-- <ul  class="select_item">
					<li v-for="(item,index) in selectItemList" @click="query_select(index,item.txt)" :class="queryIndex == index ? 'activeQuery' : ''">
						<span>{{item.txt}}</span>
						<img v-show="itemShow" :src="item.imgurl" alt=""/>
					</li>
				</ul> -->
			</div>
			<!-- 收藏作者 书本 -->
			<div v-show="selectItem" v-for="(item,itemindex) in collect_author" :key="itemindex">
				<div class="bookAuther" @touchstart="gotouchstart(item.collect_id,'auther')" @touchmove="gotouchmove" @touchend="gotouchend">
					<div class="autherImg">
						<img :src="item.author_avatar" alt="" @click="toZz(item.collect_id)" v-if="item.author_avatar? true : false"/>
						<span @click="toZz(item.collect_id)">{{item.author_pename}}</span>
						<div class="del" v-show="isDel" @click="del_collect(item.collect_id)">
							<img src="../../assets/img/dele.png" alt="">
						</div>
					</div>
					<div class="state_book">最近更新作品 <div class="timeBox">
							<p class="timeTit">最近更新时间：</p>
							<p class="timedata"><span>{{formatDateTime(item.new_work.updatetime)}}</span></p>
						</div>
					</div>
					<div class="bookBox" @click="jumpBookinfo(item.new_work.id)">
						<div class="bookImg">
							<img v-if='item.new_work.cover_image != undefined' :src="$api.$BASE_URL_img + item.new_work.cover_image" alt="" />
						</div>
						<div class="bookInfo_relative">

							<div class="bookInfo_absolute">
								<div class="bookName_updataTime">
									<div class="updataTime">
										<p class="bookName">{{item.new_work.name}}</p>
									</div>
								</div>
								<div class="typeIntroBox">
									<p class="bookType">{{item.new_work.original_name}} - {{item.new_work.appetency_name}} - {{item.new_work.epoch_name}} - {{item.new_work.type_name}}</p>
									<div class="introduction">
										{{item.new_work.introduce}}
										<!-- <div v-model="">{{item.introduce}}</div> -->
										<!-- <div v-model="">{{item.introduce}}<span v-show="item.introduce.length > 18 ? true : false">...</span></div> -->
									</div>
								</div>
								<div class="book_button">
									<button v-for="i in item.new_work.lable" >{{i}}</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				
			</div>
			<div v-if="collect_author.length == 0" class="zwsjToast">
				<img src="../../assets/img/data_null.png" alt="">
			</div>
		</div>
		<!-- v-if="collect_user.length" -->
		<div class="followBoxItem">
			<!-- 排序方式 -->
			<div class="solt">
				<div @click="toggle('collect_user')">
					<!-- <span v-model="queryTitle">{{queryTitle}}</span> -->
					<span>我收藏的读者</span>
					<img :class="showcollect_user == true ? 'up' : ''" src="../../assets/img/downarr.png" alt="" />
				</div>
				<!-- <ul v-show="selectItem" class="select_item">
					<li v-for="(item,index) in selectItemList" @click="query_select(index,item.txt)" :class="queryIndex == index ? 'activeQuery' : ''">
						<span>{{item.txt}}</span>
						<img v-show="itemShow" :src="item.imgurl" alt=""/>
					</li>
				</ul> -->
			</div>
			<!-- 收藏读者 书本 -->
			<div v-show="showcollect_user" v-for="(item,index) in collect_user" :key="index">
				<div class="bookAuther" @touchstart="gotouchstart(item.collect_id,'userRead')" @touchmove="gotouchmove" @touchend="gotouchend">
					<div class="autherImg">
						<img :src="item.user_avatar" alt="" @click="toDz(item.collect_id)" v-if="item.user_avatar? true : false"/>
						<span @click="toDz(item.collect_id)">{{item.author_nickname}}</span>
						<!-- <div class="del" v-show="isDel" @click="cancel_collect(item.collect_id)">
							<img src="../../assets/img/dele.png" alt="">
						</div> -->
					</div>
					<div class="autherImg" v-if="!item.user_avatar? true : false">
						<img src="../../assets/img/headerImg.png" alt="" @click="toDz(item.collect_id)" />
						<span @click="toDz(item.collect_id)">作者名称</span>
						<div class="del" v-show="isDel" @click="cancel_collect(item.collect_id)">
							<img src="../../assets/img/dele.png" alt="">
						</div>
					</div>
					<div v-if='item.book_name != null'>
						<div class="state_book">最近更新作品
							<div class="timeBox">
								<p class="timeTit">最近更新时间：</p>
								<p class="timedata"><span>{{item.updatetime}}</span><span>10:39:30</span></p>
							</div>
						</div>
						<div class="bookBox">
							<div class="bookImg" @click="jumpBookinfo(item.books_id)">
								<img v-if='item.cover_image!= undefined' :src="$api.$BASE_URL_img +item.cover_image" alt="" />
							</div>
							<div class="bookInfo_relative">
								<div class="bookInfo_absolute">
									<div class="bookName_updataTime">
										<div class="updataTime">
											<p class="bookName">{{item.book_name}}</p>
										</div>
									</div>
									<div class="typeIntroBox">
										<p class="bookType">{{item.type_name}}</p>
										<div class="introduction">
											{{item.introduce}}
										</div>
									</div>
									<div class="book_button">
										<button>{{item.epoch_name}}</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				
			</div>
			<div v-if="collect_user.length == 0" class="zwsjToast">
				<img src="../../assets/img/data_null.png" alt="">
			</div>
		</div>
		
		<!-- deleShow -->
		<div class="luntantost" v-show="deleShow">
			<!-- <img src="../../assets/img/cat.png" alt=""> -->
			<div class="luntantostbgc">
				<div @click="addHfFn" class="active">删除关注</div>
		
			</div>
		</div>
		<div class='mask' v-show="deleShow" @click="hideTost01"></div>
	</div>
</template>

<script>
	import {
		Toast,
		Dialog,
	} from 'vant';
	export default {
		data() {
			return {
				txtLength: '灵异网游文，剑三背景，偶尔魔兽一下灵异',
				queryIndex: 0,
				// queryTitle: '我收藏的作者',
				selectItem: true,
				showcollect_user: true,
				collect_author: [], //收藏的作者
				collect_user: [], //收藏的读者
				showBox: true,
				isDel: false,
				deleShow: false,
				userCategory: '',
			}
		},
		created() {
			this.get_my_follow()
		},
		methods: {
			gotouchstart(id,userCategory) {
				// alert(id)
				this.clearHfId = id;
				this.userCategory = userCategory;
				let that = this;
				clearTimeout(that.timeOutEvent); //清除定时器
				that.timeOutEvent = setTimeout(function() {
					//执行长按要执行的内容，
					that.deleShow = true;
				}, 600); //这里设置定时
			},
			//手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
			gotouchend() {
				clearTimeout(this.timeOutEvent);
				if (this.timeOutEvent != 0) {
					//这里写要执行的内容（尤如onclick事件）
					// that.tostShow = true;
				}
			},
			//如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按 
			gotouchmove() {
				clearTimeout(this.timeOutEvent); //清除定时器
				this.timeOutEvent = 0;
			},
			addHfFn(){
				Dialog.confirm({
						// title: '',
						message: '删除该关注',
					})
					.then(() => {
						if(this.userCategory == 'auther'){
							this.$axios.post(`${this.$api.cancel_collect}?user_id=${this.clearHfId}`).then(res => {
								if (res.data.code == 1) {
									this.get_my_follow(); //获取作者专栏
									this.deleShow = false;
								}
								Toast(res.data.msg);
								this.get_my_follow();
							})
						}else if(this.userCategory == 'userRead'){
							this.$axios.post(`${this.$api.collect_user}?user_id=${this.clearHfId}`).then(res => {
								if (res.data.code == 1) {
									this.get_my_follow(); //获取作者专栏
									this.deleShow = false;
								}
								Toast(res.data.msg);
							
							})
						}
						
						
						this.deleShow = false;
					})
					.catch(() => {
						// on cancel
					});
			},
			hideTost01(){
				this.deleShow = false;
			},
			toggle(a) {
				if (a == 'author') {
					this.selectItem = !this.selectItem
				} else if (a == "collect_user") {
					this.showcollect_user = !this.showcollect_user
				}
			},
			get_my_follow() {
				this.$axios.post(this.$api.my_follow).then(res => {
					if (res.data.data != null) {
						console.log(res)
						if (res.data.data.collect_author.length != 0 || res.data.data.collect_author != []) {
							this.collect_author = res.data.data.collect_author;
						}
						if (res.data.data.collect_user.length != 0 || res.data.data.collect_user != []) {
							this.collect_user = res.data.data.collect_user;
						}
						for(var a = 0 ; a< this.collect_user.length ; a++){
							if (this.collect_user[a].user_avatar.indexOf("https://thirdwx.qlogo.cn/") != -1) {
								this.collect_user[a].user_avatar =this.collect_user[a].user_avatar;
							} else if(this.collect_user[a].user_avatar.indexOf("http://thirdqq.qlogo.cn/") != -1){
								this.collect_user[a].user_avatar = this.collect_user[a].user_avatar;
							}else {
								this.collect_user[a].user_avatar = `${this.$api.$BASE_URL_img}${this.collect_user[a].user_avatar}`;
							}
						}
						for(var i = 0 ; i< this.collect_author.length ; i++){
							if (this.collect_author[i].author_avatar.indexOf("https://thirdwx.qlogo.cn/") != -1) {
								this.collect_author[i].author_avatar =this.collect_author[i].author_avatar;
							} else if(this.collect_author[i].author_avatar.indexOf("http://thirdqq.qlogo.cn/") != -1){
								this.collect_author[i].author_avatar = this.collect_author[i].author_avatar;
							}else if(this.collect_author[i].author_avatar != ""){
								this.collect_author[i].author_avatar = `${this.$api.$BASE_URL_img}${this.collect_author[i].author_avatar}`;
							}
						}
						
					} else {
						this.showBox = false;
						Toast(res.data.msg)
					}
				})
			},
			// 跳转详情页
			jumpBookinfo(val) {

				this.$router.push({
					path: '/bookinfo',
					query: {
						id: val,
						com_name: 'cp',
						gzPage: 'gzPage'
					}
				})
			},
			//读者专栏
			toDz(val) {
				this.$router.push({
					path: '/dzzhuanlan',
					query: {
						user_id: val
					}
				})
			},
			formatDateTime(dateNum) {
				var date = new Date(dateNum * 1000);
				return date.getFullYear() + "-" + fixZero(date.getMonth() + 1, 2) + "-" + fixZero(date.getDate(), 2) + " " +
					fixZero(date.getHours(), 2) + ":" + fixZero(date.getMinutes(), 2) + ":" + fixZero(date.getSeconds(), 2);;

				function fixZero(num, length) {
					var str = "" + num;
					var len = str.length;
					var s = "";
					for (var i = length; i-- > len;) {
						s += "0";
					}
					return s + str;
				}
			},
			//作者专栏
			toZz(val) {
				console.log(val)
				this.$router.push({
					path: '/autherZl',
					query: {
						user_id: val,
						url: 'zzzl'
					}
				})
			},
			keywordsFn(word) {
				console.log(word);
				this.$router.push({
					path: '/searchResult',
					query: {
						keywordHost: word,
						url: 'cp',
					}
				})
			},
			showCollect() {
				this.isDel = true;
			},
			del_collect(id) {
				this.$axios.post(`${this.$api.collect_user}?user_id=${id}`).then(res => {
					if (res.data.code == 1) {
						this.get_my_follow(); //获取作者专栏
						this.isDel = false;
					}
					Toast(res.data.msg);

				})
			},
			cancel_collect(id) {
				this.$axios.post(`${this.$api.collect_user}?user_id=${id}`).then(res => {
					if (res.data.code == 1) {
						this.get_my_follow(); //获取作者专栏
						this.isDel = false;
					}
					Toast(res.data.msg);

				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.followBox {
		height: 100%;
		width: 100vw;
		overflow-x: hidden;
		overflow-y: scroll;
		color: #000000;
		.zwsjToast {
			text-align: center;
			margin-top: 10%;
			img {
				width: 160px;
			}
		}

		.followBoxItem {
			margin-bottom: 10px;
			padding: 0 16px;
			background-color: #fff;
			border-bottom: 10px solid #f0f0f0;
			//排序方式
			.solt {
				position: relative;
				padding-top: 34px;
				padding-bottom: 14px;
				font-weight: bold;

				div {
					// line-height: 60px;

					span {
						font-size: 30px;
						/*px*/
					}

					img {
						margin-left: 10px;
						width: 20px;
					}

					img.up {
						transform: rotate(180deg);
					}

				}

				ul {
					position: absolute;
					top: 100px;
					background-color: #fff;
					z-index: 100;

					li {
						line-height: 50px;
						border-bottom: 1px solid #f0f0f0;

						span {
							font-size: 28px;
							/*px*/
						}

						img {
							margin-left: 10px;
							width: 20px;
							height: 20px;
						}
					}

					.select_item {
						width: 100px;
						border-radius: 20px;
					}

					.activeQuery {
						color: #ff4081;
					}
				}
			}

			//收藏作者 -- 书本
			.bookAuther {
				background-color: #fff;
				padding: 14px 0px;
				border-bottom: 1px solid #f0f0f0;
				/*no*/

				// 头像
				.autherImg {
					height: 80px;
					position: relative;

					img {
						width: 80px;
						height: 80px;
						border-radius: 50%;
						vertical-align: middle;
						box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.2);
					}

					span {
						padding-left: 30px;
						font-size: 30px;
						/*px*/
					}

					.del {
						position: absolute;
						top: 10px;
						right: 0px;
						width: 55px;
						height: 55px;

						img {
							width: 100%;
							height: 100%;
							box-shadow: 0 0 0 rgba(0, 0, 0, 0);
						}
					}
				}

				.state_book {
					width: calc(100vw - 32px);
					padding-top: 12px;
					color: #9d9d9d;
					position: relative;

					// 时间 日期
					.timeBox {
						position: absolute;
						top: 0px;
						right: 0;
						font-size: 22px;
						/*px*/
						text-align: left;
						// padding-left: 10px;
						white-space: nowrap;
						color: #9d9d9d;


						p {
							padding-top: 12px;
							display: inline-block;
						}
					}
				}

				.bookBox {
					display: flex;
					padding-top: 25px;
					padding-bottom: 15px;

					.bookImg {
						width: 180px;
						height: 270px;
						overflow: hidden;
						-webkit-box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
						/*no*/
						-moz-box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
						/*no*/
						box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);

						/*no*/
						img {
							width: 180px;
							height: 270px;
							vertical-align: middle;
						}
					}

					.bookInfo_relative {
						flex: 1;
						margin-left: 20px;
						position: relative;

						.bookInfo_absolute {
							position: absolute;
							top: 50%;
							transform: translateY(-50%);
							left: 0;
							width: 100%;

							.bookName_updataTime {

								.updataTime {
									// padding-top: 10px;
									display: flex;
									// justify-content: space-between;
									// line-height: 40px;


									.bookName {
										font-size: 30px;
										/*px*/
										width: 50%;
										height: 40px;
										color: #000000;
										overflow: hidden;
										overflow-x: scroll;
									}
								}
							}

							.typeIntroBox {
								color: #000;
								margin-top: 20px;
								opacity: 0.7;

								.bookType {
									color: #000;
									opacity: 0.7;
									padding-bottom: 20px;
									font-size: 24px;/*px*/
								}

								.introduction {
									height: 65px;
									overflow: hidden;
									color: #000;
									opacity: 0.7;
									font-size: 24px;
									/*px*/
									overflow: hidden;
									// text-overflow: ellipsis;
									// display: -webkit-box;
									// -webkit-box-orient: vertical;
									-webkit-line-clamp: 2;
								}
							}

							.book_button {
								// margin-top: 15px;
								// display: flex;
								// align-items: center;

								button {
									border: 0;
									outline: none;
									border: 1px solid #fec6d5;
									/*no*/
									border-radius: 28px;
									padding: 0px 20px;
									display: inline-block;
									line-height: 36px;
									/*px*/
									background-color: #fff8fa;
									color: #fa7298;
									margin-right: 20px;
									font-size: 24px;
									/*px*/
									overflow: hidden;
									// text-overflow: ellipsis;
									// white-space: nowrap;
									margin-top: 10px;
								}

								.active {
									background-color: #fa7298;
									color: #ffffff;
								}
							}
						}
					}
				}
			}


		}

		//弹窗
		.luntantost {
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100vw;
			// height: 454px;
			background: url(../../assets/img/pltost.png) no-repeat;
			background-size: 100%;
			z-index: 100;
		
			img {
				position: absolute;
				bottom: 40px;
				left: 0;
				width: 100%;
			}
		
			.luntantostbgc {
				margin-top: 124px;
				z-index: 10000 !important;
				background: url(../../assets/img/dog.png) no-repeat #fff;
				background-size: 100%;
				background-position: 0px 50%;
		
				div {
					line-height: 120px;
					text-align: center;
					color: #737373;
					font-size: 30px;
					/*px*/
					z-index: 1000 !important;
				}
		
				div.active {
					color: #ff4081;
				}
		
			}
		
		}
		.mask {
			position: absolute;
			bottom: 0px;
			left: 0;
			width: 100vw;
			height: 100vh;
			background-color: rgba(0, 0, 0, .3);
		}
	}
</style>
